import { Text, Space, Avatar, Button } from 'farmhub-ui-core';

import { useAppSelector } from 'app';
import { selectAppState } from 'slice';
import { LOGO } from 'utils';

import * as S from './styles';
import { Content } from './styles';

type ErrorAccessDomainProps = {
  isLoading: boolean;
  onSignIn: VoidFunction;
  onSignUp: VoidFunction;
};

const ErrorAccessDomainDesktop = ({
  isLoading,
  onSignIn,
  onSignUp,
}: ErrorAccessDomainProps): JSX.Element => {
  const app = useAppSelector(selectAppState);

  return (
    <>
      <S.Container>
        <Content>
          <Avatar size={84} src={app?.system?.avatar ?? LOGO} />

          <Space height={24} />
          <Text color="dark" size="lg" weight="extraBold">
            Đăng nhập
          </Text>
          <Space height={12} />
          <Text
            color="main"
            style={{ maxWidth: '420px', textAlign: 'center' }}
            weight="bold"
          >
            Chào mừng bạn đến với {app?.system?.displayName ?? 'HUBADMIN'}
          </Text>
          <Space height={4} />
          <Text
            color="secondary"
            style={{ maxWidth: '420px', textAlign: 'center' }}
          >
            Hiện tại tên miền bạn chưa được hệ thống phê duyệt. Vui lòng liên hệ
            với chúng tôi để hỗ trợ.
          </Text>
          <Space height={18} />
          <Button
            disabled={isLoading}
            height="50px"
            width="420px"
            onClick={() => {
              onSignIn();
            }}
          >
            Đăng nhập
          </Button>
          <Space height={12} />
          <Button
            ghost
            disabled={isLoading}
            height="50px"
            width="420px"
            onClick={() => {
              onSignUp();
            }}
          >
            Đăng ký
          </Button>
          <Space height={18} />
          <Text
            color="secondary"
            size="xxs"
            style={{
              maxWidth: '420px',
              textAlign: 'center',
              fontStyle: 'italic',
            }}
          >
            Vui lòng cho phép lưu Cookie và tự động bật cửa sổ
          </Text>
        </Content>
      </S.Container>
    </>
  );
};

export default ErrorAccessDomainDesktop;
